import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Switch } from 'components/atoms/switch/switch';
import { GlobalSettingsEnableSwitcher } from 'components/molecules/settings/global-setting-enable-switcher';
import { BodyShort01 } from 'components/styles';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
import { Section } from './components';

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

const SectionWrapper = styled(Section)`
  padding-top: 0;
  padding-bottom: var(--spacing-04);
`;

const Description = styled.div`
  ${BodyShort01};
  color: var(--gray-70);
  margin-top: var(--spacing-02);
  margin-bottom: var(--spacing-05);
`;

interface Props {
  enabled: boolean;
  onStateChange: (value: boolean) => void;
}

export const FeatureSwitch: FC<Props> = ({ enabled, onStateChange }) => {
  const isNew = useAntdRlUISwitcher();

  return (
    <SectionWrapper>
      {isNew ? (
        <GlobalSettingsEnableSwitcher
          onChangeSettings={(checked) => onStateChange(checked)}
          enableSetting={enabled}
          title={
            <FormattedMessage id="settings.credit_notes_essentials.title" />
          }
          description={
            <FormattedMessage id="settings.credit_notes.enable_message" />
          }
          dataCy="switch.credit-note-feature"
        />
      ) : (
        <>
          <Description>
            <FormattedMessage id="settings.credit_notes.enable_message" />
          </Description>
          <SwitchWrapper data-cy="switch-wrapper">
            <Switch
              size="small"
              checked={enabled}
              onChange={(checked) => onStateChange(checked)}
              data-cy="switch.credit-note-feature"
            />
            {enabled ? (
              <FormattedMessage id="enabled" />
            ) : (
              <FormattedMessage id="disabled" />
            )}
          </SwitchWrapper>
        </>
      )}
    </SectionWrapper>
  );
};
